// extracted by mini-css-extract-plugin
module.exports = {"BaseButton":"BaseButton_BaseButton__jVey1","smallText":"BaseButton_smallText__OTr0y","primary":"BaseButton_primary__HtB_N","error":"BaseButton_error__6a_Lv"};